import { useNavigate } from "react-router-dom";

const useGoBackOrDefault = ({defaultUrl = "/", location = window.location}) => {
  const navigate = useNavigate();

  return () => {
    const prevPath = document.referrer;
    const currentUrl = window.location.href;
    const currentHost = window.location.origin;

    const isSameOrigin = prevPath.startsWith(currentHost);
    const isOnboardingPage =
      prevPath.includes("/onboarding") ||
      location.pathname.includes("/onboarding");

    const isNotSelf = prevPath !== currentUrl;

    const isValidPrevPath = isSameOrigin && !isOnboardingPage && isNotSelf;

    // Extract just the pathname from the referrer
    const referrerPath = prevPath.replace(currentHost, "");

    if (window.history.length > 1 && isValidPrevPath) {
      // Avoid navigating if referrerPath === location.pathname
      if (referrerPath !== location.pathname) {
        navigate(-1);
        return;
      }
    }

    navigate(defaultUrl, { replace: true });
  };
};

export default useGoBackOrDefault;
